var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2048v2048H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M255.999 255.999h1536v1536h-1536z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "m1303.19 263.999 328.759 329.158h-269.982c-32.328 0-58.776-26.448-58.776-58.776V263.999z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M454.851 263.999h848.395v268.747c0 33.228 27.184 60.411 60.411 60.411h268.344V1408c0 22-17.999 40-40 40H454.852c-22 0-39.998-18-39.998-40V304c0-22 17.999-40 39.999-40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    fillRule: "nonzero",
    d: "M671.999 763.342H1408v64.002H671.999zM671.999 987.337H1408v64.003H671.999z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M337.396 1226.19h1373.21c22.375 0 42.735 9.234 57.51 24.108 14.738 14.835 23.887 35.238 23.887 57.618v394.353c0 22.381-9.15 42.782-23.887 57.618-14.777 14.874-35.136 24.109-57.51 24.109H337.396c-22.373 0-42.735-9.235-57.512-24.109-14.736-14.833-23.885-35.234-23.885-57.618v-394.353c0-22.381 9.149-42.783 23.885-57.618 14.775-14.874 35.137-24.108 57.512-24.108z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M673.874 1684.05v-297.333H567.708v-60.584h284.417v60.584H746.208v297.333h-72.334zm188.501 0 122.333-186.75-110.832-171.167h84.416l71.833 115 70.251-115h83.75l-111.333 173.834 122.333 184.083h-87.167l-79.333-123.75-79.583 123.75h-86.667zm450.416 0v-297.333h-106.166v-60.584h284.417v60.584h-105.917v297.333h-72.334z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.decbc5a90f5f469568296151098f3257.svg";
export { ForwardRef as ReactComponent };